/**
 * Runs async task factories with a bounded number in flight at a time.
 *
 * Used to stream paginated chunk requests a few at a time instead of firing them all at
 * once (Promise.all over dozens of chunks stampedes the backend — thread / connection-pool
 * exhaustion — and 504s the whole page on wide periods).
 *
 * @param {Array<() => Promise<any>>} taskFactories functions that each start one async task
 * @param {number} limit max number running concurrently
 */
export const runWithConcurrency = async (taskFactories, limit) => {
  let next = 0;
  const runners = Array.from(
    { length: Math.min(Math.max(1, limit), taskFactories.length) },
    async () => {
      while (next < taskFactories.length) {
        const current = next;
        next += 1;
        await taskFactories[current]();
      }
    }
  );
  await Promise.all(runners);
};
